import classNames from "classnames";
import {FiX} from "react-icons/fi";

import {AlertHeaderProps} from "@/components/alert/subComponents/AlertHeader/AlertHeader.types.ts";
import {IconButton} from "@/components/iconButton/IconButton.tsx";

import styles from "./AlertHeader.module.scss";

const AlertHeader = ({children, className, onClose, dismissible}: AlertHeaderProps) => {
  return (
    <div className={classNames(styles.header, className)}>
      <div className={styles.headerContent}>{children}</div>
      {dismissible && <IconButton variant={"ghost"} size={"fitIcon"} onClick={onClose} icon={FiX} />}
    </div>
  );
};

AlertHeader.displayName = "AlertHeader";

export {AlertHeader};
